import Global from './global';

const KIAF_WEBSQL_DB_NAME = 'kiaf_log_db';
const KIAF_WEBSQL_DB_NEW_VERSION = 1;
const KIAF_LOG_TABLE = 'kiaf_log_table';
const KIAF_MEMORY_TIMER_INTERVAL = 60000; // 内存监听定时器间隔，单位：毫秒
const KIAF_LOG_VALID_DAYS = 5; // 日志有效期，5天，超过3天会被删除

class Logger {
  constructor() {
    this.db = undefined; // 数据库链接
    this.store = undefined; // 数据表
    this.logList = []; // 日志列表，添加日志时先添加到这个数组中，再存入数据库
    this.writeTimer = undefined; // 定时器，需要写数据时，开启一个3秒的 timeout
    this.memoryTimer = undefined; // 定时器，每间隔60秒记录一次当前的内存信息

    // 初始化数据库
    this.initDB();
  }

  /* --------------------------- 内部方法 --------------------------- */
  // 初始化数据库
  initDB() {
    // 打开数据库
    let request = indexedDB.open(
      KIAF_WEBSQL_DB_NAME,
      KIAF_WEBSQL_DB_NEW_VERSION
    );

    // 监听结果
    request.onerror = (e) => {
      console.log('logger >>> 打开数据库失败');
    };
    request.onsuccess = () => {
      console.log('logger >>> 打开数据库成功');
      // 获取数据库
      this.db = request.result;

      // 开启内存信息监听的定时器
      this.startMemoryTimer();
    };
    // 如果指定的版本号，大于数据库的实际版本号，就会发生数据库升级事件upgradeneeded。
    request.onupgradeneeded = (event) => {
      console.log('logger >>> 数据库版本更新', event);
      this.db = event.target.result;

      // 创建表
      this.createTable(request, event);
    };
  }

  // 创建表
  createTable(request, event) {
    console.log('logger >>> createTable - event = ', event);
    let objectStore;

    // 创建数据表
    if (!this.db.objectStoreNames.contains(KIAF_LOG_TABLE)) {
      console.log('logger >>> 创建表 --- ');
      objectStore = this.db.createObjectStore(KIAF_LOG_TABLE, {
        autoIncrement: true
        // keyPath: 'id'
      });

      // 创建索引
      objectStore.createIndex('username', 'username', { unique: false });
      objectStore.createIndex('timestamp', 'timestamp', { unique: false });
      objectStore.createIndex('username_timestamp', ['username', 'timestamp'], {
        unique: false
      });
      objectStore.createIndex('username_type', ['username', 'type'], {
        unique: false
      });
      objectStore.createIndex('windowId', 'windowId', { unique: false });
      objectStore.createIndex(
        'username_windowId_time',
        ['username', 'windowId', 'timestamp'],
        { unique: false }
      );
    }

    if (event.oldVersion == 0) {
      // 第一次创建数据库
    } else {
      // 非第一次创建数据库，数据表已经存在，可更新索引
      objectStore = request.transaction.objectStore(KIAF_LOG_TABLE);

      // 增加或删除索引
    }
  }

  // 清除写日志的定时器
  clearWriteTimer() {
    this.writeTimer && clearTimeout(this.writeTimer);
  }

  /* --------------------------- Public --------------------------- */
  // 开启定时器，记录内存信息
  startMemoryTimer() {
    if (window.performance && window.performance.memory) {
      this.memoryTimer = setInterval(() => {
        // 获取当前内存信息
        let memory = window.performance.memory;

        // 添加日志
        let logData = {
          type: 'memory',
          memory: {
            total: memory.totalJSHeapSize,
            used: memory.usedJSHeapSize,
            limit: memory.jsHeapSizeLimit
          }
        };
        this.addLog(logData);
      }, KIAF_MEMORY_TIMER_INTERVAL);
    } else {
      console.warn(
        'logger >>> 当前浏览器不支持 window.performance.memory 接口'
      );
    }
  }

  // 清除监听内存的定时器
  stopMemoryTimer() {
    this.memoryTimer && clearInterval(this.memoryTimer);
  }

  /**
   * 添加日志
   * @param {Object} log 日志信息对象
   */
  addLog(log) {
    // 添加 username, timestamp, windowId
    let data = {
      username: Global.getUserInfo().username || '',
      timestamp: Date.now(),
      windowId: Global.getSessionWindowId() || '',
      ...log
    };
    this.logList.push(data);

    // 如果日志数量到达10条（但3秒的定时器还未触发），开启存储
    if (this.logList.length >= 10) {
      this.clearWriteTimer();
      this.insertLogs();
    } else {
      // 日志数量未达到10条，清除旧定时器，并重新开启一个新的定时器，3秒之后存储日志
      this.clearWriteTimer();
      this.writeTimer = setTimeout(() => {
        this.insertLogs();
      }, 3000);
    }
  }

  // 插入数据（将当前 logList 中所有数据都存入数据库）
  insertLogs() {
    if (!this.logList || this.logList.length == 0) {
      return;
    }

    // copy 数组，并清空 logList
    let list = JSON.parse(JSON.stringify(this.logList));
    this.logList = [];

    let insertFailed = [], // 插入失败时保存在这个数组中
      count = 0,
      totalLength = list.length;

    this.store = this.db
      .transaction([KIAF_LOG_TABLE], 'readwrite')
      .objectStore(KIAF_LOG_TABLE);
    list.forEach((item) => {
      let request = this.store.add(item);

      request.onsuccess = function(event) {
        // console.log('数据写入成功 --- ', data.id);
        // console.log(event);
        count++;
        if (count >= totalLength) {
          // 全部写入完毕
          // 如果有写入失败的，将其重新添加到 logList 中
          if (insertFailed.length > 0) {
            insertFailed.forEach((failedItem) => {
              this.addLog(failedItem);
            });
          }
        }
      };

      request.onerror = function(event) {
        console.error('logger >>> 数据写入失败 --- ', item);
        count++;
        // 将添加失败的加入到 insertFailed
        insertFailed.push(item);
        if (count >= totalLength) {
          // 全部写入完毕
          // 如果有写入失败的，将其重新添加到 logList 中
          if (insertFailed.length > 0) {
            insertFailed.forEach((failedItem) => {
              this.addLog(failedItem);
            });
          }
        }
      };
    });
  }

  // 获取所有用户
  getAllUser() {
    return new Promise((resolve, reject) => {
      let list = [];
      let startTime = Date.now();
      this.store = this.db
        .transaction([KIAF_LOG_TABLE], 'readonly')
        .objectStore(KIAF_LOG_TABLE);

      // 获取索引
      let dbIndex = this.store.index('username');
      let cursor = dbIndex.openCursor(null, 'nextunique');
      cursor.onsuccess = (event) => {
        let res = event.target.result;
        if (res) {
          list.push(res.value.username);
          res.continue();
        } else {
          // 已全部读取，返回 logList
          resolve(list);
        }
      };

      cursor.onerror = (event) => {
        console.error('读取失败 --- ', event);
        reject(event);
      };
    });
  }

  // 读取当前用户全部日志数据
  readAllLogs(username) {
    return new Promise((resolve, reject) => {
      // let username = Global.getUserInfo().username || ''; // 获取当前用户名
      if (!username) {
        return resolve([]);
      }

      let list = [];
      let startTime = Date.now();
      // let store = db.transaction([KIAF_LOG_TABLE]).objectStore(KIAF_LOG_TABLE);
      this.store = this.db
        .transaction([KIAF_LOG_TABLE], 'readonly')
        .objectStore(KIAF_LOG_TABLE);
      // 获取索引
      let dbIndex = this.store.index('username');
      let range = IDBKeyRange.only(username);
      let cursor = dbIndex.openCursor(range);
      cursor.onsuccess = function(event) {
        let res = event.target.result;
        if (res) {
          list.push(res.value);
          res.continue();
        } else {
          // 已全部读取，返回 logList
          resolve(list);
        }
      };

      cursor.onerror = (event) => {
        console.error('读取失败 --- ', event);
        reject(event);
      };
    });
  }

  // 读取指定时间的数据
  readLogsByTime(timestamp) {
    return new Promise((resolve, reject) => {
      let list = [];
      // let store = db.transaction([KIAF_LOG_TABLE]).objectStore(KIAF_LOG_TABLE);
      this.store = this.db
        .transaction([KIAF_LOG_TABLE], 'readonly')
        .objectStore(KIAF_LOG_TABLE);
      let dbIndex = this.store.index('timestamp');
      let range = IDBKeyRange.upperBound(timestamp); // 查询范围 >= timestamp
      let request = dbIndex.openCursor(range);
      request.onsuccess = (event) => {
        let res = event.target.result;
        if (res) {
          list.push(res.value);
          res.continue();
        } else {
          // 已全部读取，返回 logList
          resolve(list);
        }
      };

      request.onerror = (event) => {
        reject(event);
      };
    });
  }

  // 读取指定时间范围内的数据
  readLogsBound(condition) {
    return new Promise((resolve, reject) => {
      let username = condition.username || '';
      if (!username) {
        return resolve([]);
      }

      let list = [];
      let startTime = Date.now();
      // let store = db.transaction([KIAF_LOG_TABLE]).objectStore(KIAF_LOG_TABLE);
      this.store = this.db
        .transaction([KIAF_LOG_TABLE], 'readonly')
        .objectStore(KIAF_LOG_TABLE);
      let dbIndex = this.store.index('username_timestamp');
      // 前闭后开
      let range = IDBKeyRange.bound(
        [condition.username, condition.startTime],
        [condition.username, condition.endTime],
        false,
        true
      );
      let request = dbIndex.openCursor(range);
      request.onsuccess = (event) => {
        let res = event.target.result;
        if (res) {
          list.push(res.value);
          res.continue();
        } else {
          // 已全部读取，返回 logList
          resolve(list);
        }
      };

      request.onerror = (event) => {
        reject(event);
      };
    });
  }

  // 删除过期的日志数据
  deleteExpiredLogs() {
    // 获取10天前的时间戳，在这个时间之前的日志全部删除
    let today = new Date().setHours(0, 0, 0, 0);
    let timestamp = today - KIAF_LOG_VALID_DAYS * 86400 * 1000;
    this.deleteLogsBeforeTime(timestamp);
  }

  // 删除指定时间之后的所有日志数据
  deleteLogsBeforeTime(timestamp) {
    return new Promise((resolve, reject) => {
      let startTime = Date.now();
      // 获取表格
      this.store = this.db
        .transaction(KIAF_LOG_TABLE, 'readwrite')
        .objectStore(KIAF_LOG_TABLE);

      // 获取索引
      let dbIndex = this.store.index('timestamp');
      // 构建查询
      let range = IDBKeyRange.upperBound(timestamp);
      // 查询数据并删除
      let request = dbIndex.openCursor(range);
      let count = 0;
      request.onsuccess = (event) => {
        let res = event.target.result;
        if (res) {
          res.delete(); // 删除当前记录
          count++;
          res.continue();
        } else {
          // 已全部读取，返回 logList
          resolve(count);
        }
      };
    });
  }
}

export default new Logger();
